<template>
  <div>
    <modal-provider name="not-available-products"
                    :width="900"
                    @before-open="beforeOpen"
                    @closed="modalClosed">
      <template v-slot:modal-heading>
        <h3 class=" modal__title">
          {{ title }}
        </h3>
        <p class="modal__subtitle">
          {{ subtitle }}
        </p>
      </template>
      <div class="not-available-products">
        <div v-if="endedProductsInfo.length" class="not-available-products__content">
          <div class="not-available-products__table-header">
            <span class="not-available-products__table-header--text">{{ $t('was') }}</span>
            <span class="not-available-products__table-header--text">{{ $t('now') }}</span>
          </div>
          <template v-for="productItem in computedProducts">
            <div v-if="isProductItemEnded(productItem.id)"
                 :key="productItem.id"
                 class="not-available-products__content-item"
            >
              <ProductCard
                class="not-available-products__product-info"
                notAvailablePopup
                :class="{
                  'not-available-products__product-info--expanded': productItem.quantity === 0
                }"
                :product="productItem"
              >
                <div class="not-available-products__product-quantities">
                  <span class="not-available-products__product-quantities-item">
                    {{ getEndedItemQuantity(productItem.id, true) }}
                    {{ $t('cart_piece') }}
                  </span>
                  <div class="arrow-grey"></div>
                  <span
                    class="not-available-products__product-quantities-item"
                    v-if="getEndedItemQuantity(productItem.id)"
                  >
                    {{ getEndedItemQuantity(productItem.id) }}
                    {{ $t('cart_piece') }}
                  </span>
                  <div
                    v-else-if="getEndedItemQuantity(productItem.id) === 0"
                    class="not-available-products__product-quantities-item not-available-products__product-quantities-item--report"
                  >
                    <span>{{ $t('not_available') }}</span>
                    <WaitListBtn :product-id="productItem.id" link-style class="not-available-products__wait-list" />
                  </div>
                </div>
              </ProductCard>
            </div>
          </template>
        </div>
        <Button class="not-available-products__btn" type="button" @click.native="$modal.hide('not-available-products')">
          {{ $t('good') }}
        </Button>
      </div>
    </modal-provider>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Button from '../../inputs/Button'
import ProductCard from '../../cart/ProductCard'
import WaitListBtn from '@/components/product/product-page/WaitListBtn'

export default {
  name: 'PopupNotAvailableProducts',
  components: { Button, ProductCard, WaitListBtn },
  data () {
    return {
      title: '',
      subtitle: '',
      endedProductsInfo: [],
      allProducts: []
    }
  },
  computed: {
    computedProducts () {
      return this.allProducts.length > 0 ? this.allProducts : this.$store.state.cart.products
    }
  },
  methods: {
    ...mapActions(['GET_FULL_CART']),
    beforeOpen (e) {
      const {
        missing_products: missingProducts,
        missing_quantity: missingQuantity,
        error_message_heading: title,
        error_message_subtitle: subtitle,
        allProducts
      } = e.params

      this.allProducts = allProducts || []

      const productsArray = []

      if (missingProducts) {
        missingProducts.forEach(el => {
          productsArray.push(el)
        })
      }

      if (missingQuantity) {
        missingQuantity.forEach(el => {
          productsArray.push(el)
        })
      }

      this.title = title
      this.subtitle = subtitle
      this.endedProductsInfo = productsArray
    },
    modalClosed () {
      this.allProducts = []
      this.GET_FULL_CART()
    },
    isProductItemEnded (id) {
      return this.endedProductsInfo?.find(el => el.product_id === id) !== undefined
    },
    getEndedItemQuantity (id, getPreviousQuantity) {
      const currentProduct = this.endedProductsInfo.find(el => el.product_id === id)
      return getPreviousQuantity ? currentProduct.quantity_from_cart : currentProduct.quantity
    }
  }
}
</script>

<style scoped lang="sass">

.not-available-products__table-header
  font-size: 14px
  font-weight: 400 //Rubik 300
  color: $placeholder-color
  display: flex
  padding-left: 50%
  justify-content: space-around

  +mmax($between-phone-tablet)
    display: none

  &--text
    padding: 40px 0 10px 0

.not-available-products__product-info
  border-bottom: none

.not-available-products__content-item
  border-top: 1px solid #E1E1E1
  display: flex
  position: relative

  &:last-child
    border-bottom: 1px solid #E1E1E1

  +mmax($between-phone-tablet)
    flex-direction: column

.not-available-products__product-info--expanded
  +mmax($between-phone-tablet)
    padding-bottom: 50px

.not-available-products__product-quantities
  display: flex
  align-items: center
  justify-content: space-around
  width: 80%

  +mmin(661)
    width: calc((100% + 120px) / 2)
    margin-top: -60px
    position: relative
    justify-content: center

.not-available-products__product-quantities-item
  color: $text-color
  font-size: 14px
  font-weight: 400 //Rubik 300
  width: 50%
  display: flex
  justify-content: center
  align-items: center

  +mmax($between-phone-tablet)
    width: auto
    font-size: 18px

  &--report
    display: flex
    flex-direction: column
    align-items: center

.arrow-grey
  +mmax($between-phone-tablet)
    min-width: 50px
    height: 16px
    background-image: url(/img/svgo/cart/back.svg)
    background-size: 16px 16px
    background-repeat: no-repeat
    background-position: 50%
    background-color: transparent
    transform: scale(-1, -1)
    opacity: .5

.link
  background: transparent
  margin-top: 20px
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmax($between-phone-tablet)
    margin-top: 40px
    position: absolute
    left: 50%
    transform: translateX(-50%)

.not-available-products__wait-list
  display: flex
  flex-flow: column wrap
  align-items: center
  margin-top: 10px

  +mmin(661)
    margin-top: 20px

.not-available-products__btn
  width: 200px
  margin: 50px auto 30px auto
</style>
